import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: r => { require(['./index'], r) },
      meta: { title: '首页' }
    },
    {
      path: '/nonsupport',
      name: 'nonsupport',
      component: r => { require(['./nonsupport'], r) },
      meta: { title: '不支持' }
    },
    {
      path: '/prepare',
      name: 'prepare',
      component: r => { require(['./prepare'], r) },
      meta: { title: '准备' }
    }
  ]
})
